// extracted by mini-css-extract-plugin
export var completionBody = "_j5-2";
export var completionCard = "_j5-0";
export var completionFooter = "_j5-3";
export var completionTitle = "_j5-1";